import { InfoOutlineIcon } from '@carboncopyco/icons';
import { ColorHex, TextCaption, Tooltip } from '@carboncopyco/ui';
import classNames from 'classnames';
import { useRef } from 'react';

type TableInfoTooltipProps = {
  label: string;
  disabled?: boolean;
  widthClass?: string;
};

export const InfoIconTooltip = ({
  label,
  disabled,
  widthClass,
}: TableInfoTooltipProps) => {
  const infoIconRef = useRef<HTMLDivElement>(null);

  return (
    <>
      <div ref={infoIconRef}>
        <InfoOutlineIcon
          size={16}
          color={disabled ? ColorHex.natural200 : ColorHex.natural600}
        />
      </div>
      <Tooltip
        delay={[300, 0]}
        interactive={false}
        placement="bottom-end"
        anchorRef={infoIconRef}
        noArrow
      >
        <div
          className={classNames(
            'p-3 bg-ds-accent3-100 rounded-md flex whitespace-normal shadow-ds-edit-tool',
            widthClass
          )}
        >
          <TextCaption
            label={label}
            color="text-ds-natural-400"
          />
        </div>
      </Tooltip>
    </>
  );
};
